import { render } from "./shortlist-card.vue?vue&type=template&id=ae9c6ed8"
import script from "./shortlist-card.vue?vue&type=script&lang=js"
export * from "./shortlist-card.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__